import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { IoPerson, IoRocket, IoCodeSlash, IoSchool, IoBriefcase } from 'react-icons/io5';
import { motion } from 'framer-motion';
import '../static/css/Nav.css';
import { useTranslation } from 'react-i18next';

function Nav() {
  const location = useLocation();
  const currentPath = location.pathname;
  const { t } = useTranslation('nav');

  const items = [
    { to: '/', icon: <IoPerson />, label: t('about') },
    { to: '/trabalho', icon: <IoBriefcase />, label: t('experience') },
    { to: '/tecnologias', icon: <IoRocket />, label: t('technologies') },
    { to: '/projetos', icon: <IoCodeSlash />, label: t('projects') },
    { to: '/certificado', icon: <IoSchool />, label: t('certificates') },
  ];

  return (
    <>
      <motion.nav
        className="nav-desktop"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.45, ease: [0.25, 0.1, 0.25, 1] }}
        role="navigation"
        aria-label="Menu principal"
      >
        <div className="nav-items" role="list">
          {items.map((item) => (
            <motion.div
              key={item.to}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.93 }}
              role="listitem"
            >
              <Link
                to={item.to}
                className={`nav-link ${currentPath === item.to ? 'active' : ''}`}
                data-tooltip={item.label}
                aria-label={item.label}
                aria-current={currentPath === item.to ? 'page' : undefined}
              >
                <div className="nav-icon-box">
                  <span className="nav-icon" aria-hidden="true">
                    {item.icon}
                  </span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </motion.nav>

      <nav className="nav-mobile" role="navigation" aria-label="Menu mobile">
        {items.map((item) => {
          const isActive = currentPath === item.to;
          return (
            <Link
              key={item.to}
              to={item.to}
              className={`tab-item ${isActive ? 'active' : ''}`}
              aria-label={item.label}
              aria-current={isActive ? 'page' : undefined}
            >
              <motion.div
                className="tab-icon-wrap"
                animate={isActive ? { y: -4, scale: 1.15 } : { y: 0, scale: 1 }}
                transition={{ type: 'spring', stiffness: 400, damping: 20 }}
              >
                <span className="tab-icon" aria-hidden="true">
                  {item.icon}
                </span>
                {isActive && (
                  <motion.div
                    className="tab-dot"
                    layoutId="tab-dot"
                    transition={{ type: 'spring', stiffness: 500, damping: 30 }}
                  />
                )}
              </motion.div>
              <span className="tab-label">{item.label}</span>
            </Link>
          );
        })}
      </nav>
    </>
  );
}

export default Nav;
